import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './FileUploader.css';

export interface IFileUploadProps {
  id: string;
  label: string;
  onFileSelect: (files: File[]) => void;
}

function FileUploader(props: IFileUploadProps) {
  const onChangeHandler = (event: any) => {
    props.onFileSelect(event.target.files);
  };

  return (
    <div className="fileupload">
      <input
        id="file"
        type="file"
        name="file"
        multiple
        onChange={onChangeHandler}
        value={''}
        className="inputfile" />
      <label htmlFor="file">
        <span>{props.label}</span>
        <FontAwesomeIcon icon="folder-open" color="white" />
      </label>
    </div>
  );

}

export default FileUploader;